import { CurrencySymbol } from "utils/Utils";
import React from "react";

function PublicPreviewPriceDisplay({
  currencyInfo,
  productPrice,
  width = 16,
  height = 16,
  primaryColor,
  dir = "ltr",
  extraSpanStyles = {},
}) {
  const { currencyCode, symbol, position } = currencyInfo || {};

  if (!productPrice) return null;

  const isSAR = currencyCode === "SAR";
  const isLeft = position === "left";

  const renderSymbol = () => {
    if (isSAR) {
      return (
        <CurrencySymbol color={primaryColor} width={width} height={height} />
      );
    }
    return <span style={{ fontFamily: "inherit" }}>{symbol}</span>;
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "2px",
        fontFamily: "inherit",
        direction: dir,
      }}
    >
      {isLeft ? (
        <>
          {renderSymbol()}
          <span
            style={{
              color: primaryColor,
              fontFamily: "inherit",
              ...extraSpanStyles,
            }}
          >
            {productPrice}
          </span>
        </>
      ) : (
        <>
          <span
            style={{
              color: primaryColor,
              fontFamily: "inherit",
              ...extraSpanStyles,
            }}
          >
            {productPrice}
          </span>
          {renderSymbol()}
        </>
      )}
    </div>
  );
}

export default PublicPreviewPriceDisplay;
